import React, { useEffect, useState, useRef } from 'react';
import AboutImage from '../../../assests/images/journeyt.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import AboutImage1 from '../../../assests/jour.png'
import { Helmet } from "react-helmet-async";

const timelineData = [
  {
    year: "2018",
    left: [{ text: "The Beginning" }],
    right: [
      {
        text:
          "TekIT Software Solutions was founded with a vision to deliver reliable and innovative IT services, starting with a small yet passionate team focused on custom software development.",
      },
    ],
    bg: "bg-red-500",
  },
  {
    year: "2019",
    left: [{ text: "First Milestones" }],
    right: [
      {
        text:
          "We expanded our services into web and mobile app development, successfully onboarding our first set of global clients and laying the foundation for long-term partnerships.",
      },
    ],
    bg: "bg-yellow-500",
  },
  {
    year: "2020",
    left: [{ text: "Adapting and Evolving" }],
    right: [
      {
        text:
          "Despite global disruptions, TekIT thrived by embracing remote work culture, adopting agile practices, and offering staff augmentation services to meet growing client needs.",
      },
    ],
    bg: "bg-blue-400",
  },
  {
    year: "2021",
    left: [{ text: "Team and Client Growth" }],
    right: [
      {
        text:
          "Our client base grew rapidly across the US, UK, and India. We also scaled our internal team, bringing in top-tier developers, project managers, and quality analysts.",
      },
    ],
    bg: "bg-fuchsia-500",
  },
  {
    year: "2022",
    left: [{ text: "Innovation in Action" }],
    right: [
      {
        text:
          "TekIT ventured into AI/ML development, helping businesses leverage data-driven solutions. Our focus on emerging technologies began shaping the next phase of our journey.",
      },
    ],
    bg: "bg-green-500",
  },
  {
    year: "2023",
    left: [{ text: "Recognition and Reach" }],
    right: [
      {
        text:
          "We gained recognition for our staffing solutions and delivery excellence. With increased demand, we opened multiple development centers in India and expanded our talent pool.  ",
      },
      {
        text:
          "",
      },
    ],
    bg: "bg-gray-800",
  },
  {
    year: "2024",
    left: [{ text: "Strategic Expansion" }],
    right: [
      {
        text:
          "TekIT strengthened its position globally through strategic collaborations and participation in key industry events. We focused on leadership in AI/ML and tech-driven staffing.",
      },
    ],
    bg: "bg-purple-500",
  },
  {
    year: "2025",
    left: [{ text: "A Vision Realized" }],
    right: [
      {
        text:
          "Today, TekIT stands as a trusted global partner in AI/ML development, custom software services, and staff augmentation. With a decade of experience and a future-focused mindset, we continue to innovate, empower businesses, and build long-lasting client success stories.",
      },
    ],
    bg: "bg-indigo-800",
  },
];


const Journey = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [bgPositionY, setBgPositionY] = useState(5.69531); // Initial Y position

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // whether animation should happen only once
    });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const { isIntersecting, boundingClientRect } = entry;
        const isEnteringFromBottom = isIntersecting && boundingClientRect.top > 0;

        setIsVisible(isEnteringFromBottom);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Scroll event to adjust background position
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newPositionY = 5.69531 - scrollY * 0.5; // Adjust the multiplier as needed
      setBgPositionY(newPositionY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
    <Helmet>
        <title>Our Journey | TekIT Software Solutions</title>
        <meta name="description" content="Discover the inspiring journey of TekIT Software Solutions, from our humble beginnings to becoming a global leader in IT services. Explore our milestones, innovations, and commitment to client success." />
        <link rel="canonical" href="https://www.tekitsolution.com/tekit-journey" />
        </Helmet>
      {/* Parallax Section */}
      <section
        ref={sectionRef}
        className={`relative w-full h-[800px] lg:h-screen lg:block hidden bg-center bg-cover transition-opacity duration-700 
    ${isVisible ? 'opacity-100' : 'opacity-100'} 
    bg-no-repeat lg:bg-fixed`}
        style={{
          backgroundImage: `url(${AboutImage})`,
          backgroundPosition: `0px ${bgPositionY}px`,
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="container mx-auto h-full flex items-center justify-center text-center">
          <div className="text-white">
            {/* Your content here */}
          </div>
        </div>
      </section>
      <section
        
        className={`relative w-full lg:hidden block h-[1300px]  bg-center bg-cover transition-opacity duration-700  bg-no-repeat lg:bg-fixed`}
        style={{
          backgroundImage: `url(${AboutImage1})`,
          // backgroundPosition: `0px ${bgPositionY}px`,
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="container mx-auto h-full flex items-center justify-center text-center">
          <div className="text-white">
            {/* Your content here */}
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <div className="py-2  lg:block hidden">
        {timelineData.map((entry, index) => {
          const isEven = index % 2 === 0;
          const leftContent = isEven ? entry.left : entry.right;
          const rightContent = isEven ? entry.right : entry.left;

          // Generate multicolor year
          // const yearColors = ['bg-red-500', 'bg-green-500', 'bg-blue-500', 'bg-yellow-500', 'bg-purple-500'];
          // const coloredYear = [...entry.year].map((char, idx) => (
          //   <span key={idx} className={yearColors[idx % yearColors.length]}>
          //     {char}
          //   </span>
          // ));

          return (
            <div
              key={index}
              className={`relative flex flex-col lg:flex-row items-center justify-between gap-6 py-10 px-4 lg:px-4 ${isEven ? 'bg-white' : 'bg-gray-100'
                }`}
            >
              {/* Left Column */}
              <div className="w-full lg:w-1/3 text-center lg:text-left font-recoleta">
                {leftContent.map((item, idx) => (
                  <div key={idx} className="mb-6 2xl:ml-20 lg:ml-20">
                    <p
                      data-aos={isEven ? 'fade-right' : 'fade-left'}
                      className="text-gray-700 text-[55px] 2xl:text-[26px] lg:text-[20px]"
                    >
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>

              {/* Year Circle */}
              <div
                className={`relative z-10 ${entry.bg} text-white ${entry.year === 'Coming Soon...' ? 'text-[68px] 2xl:text-[24px]  lg:text-[20px]' : 'text-[184px] lg:text-[52px]'
                  } font-semibold rounded-full w-[680px] lg:w-[220px]  h-[680px] lg:h-[220px] flex items-center justify-center text-center`}
                data-aos="fade-up"
              >
                {entry.year}
              </div>

              {/* Right Column */}
              <div className="w-[82%] lg:w-1/3 text-center lg:text-left font-recoleta">
                {rightContent.map((item, idx) => (
                  <div key={idx} className="mb-6">
                    <p
                      data-aos={isEven ? 'fade-left' : 'fade-right'}
                      className="text-gray-700 text-[55px] lg:pr-10 2xl:text-[24px]  lg:text-[20px]"
                    >
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>

              {/* Vertical Line */}
              <div className="absolute top-0 bottom-0 left-1/2 w-px bg-blue-700 transform -translate-x-1/2 z-0 hidden lg:block"></div>
            </div>
          );
        })}
      </div>

      <div className="py-2 lg:w-[95%] 2xl:w-[96%] block lg:hidden">
        {timelineData.map((entry, index) => (
          <div
            key={index}
            className={`relative flex flex-col lg:flex-row items-center justify-between gap-6 py-10 px-4 lg:px-10 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'
              }`}
          >
            <div className="w-full lg:w-1/3 text-center lg:text-left font-recoleta">
              {entry.left.map((item, idx) => (
                <div key={idx} className="mb-6 2xl:ml-44 lg:ml-20 ">
                  <p data-aos="fade-right" className="text-gray-700 text-[55px] 2xl:text-[26px]  lg:text-[20px] ">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>

            <div
              className={`relative z-1 ${entry.bg}  text-white ${entry.year === 'Coming Soon...' ? 'text-[68px] 2xl:text-[24px]  lg:text-[20px]' : 'text-[184px] lg:text-[52px]'
                } font-semibold rounded-full w-[680px] lg:w-[220px]  h-[680px] lg:h-[220px] flex items-center justify-center`}
              data-aos="fade-up" >
              {entry.year}
            </div>

            <div className="w-[82%] lg:w-1/3 text-center lg:text-left font-recoleta">
              {entry.right.map((item, idx) => (
                <div key={idx} className="mb-6">
                  <p data-aos="fade-left" className="text-gray-700 text-[55px] 2xl:text-[24px]  lg:text-[20px] ">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
            <div className="absolute top-0 bottom-0 left-1/2 w-px bg-blue-700 transform -translate-x-1/2 z-0 hidden lg:block"></div>
          </div>
        ))}
      </div>
    </>

  );
};

export default Journey;
